export const Logo = ({ className = '', size = 'default' }: { className?: string, size?: 'default' | 'large' }) => (
  <img
    src="/docverifai-dv-logo.png"
    alt="DocVerifAI"
    width={2172}
    height={724}
    className={`block h-auto object-contain dark:brightness-0 dark:invert ${size === 'large' ? 'w-64' : 'w-40 sm:w-48'} ${className}`}
  />
);
